import { BaSeLoading, BaSeParagraph, BaSeSmall1 } from '@base/react';
import React from 'react';
import { useManageClassController } from '../../../../../../hooks/controllers/manage-class-controller';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { cpfMask } from '../../../../../../utils/formatters/cpfMask';
import { phoneMask } from '../../../../../../utils/formatters/phoneMask';

function PersonalItems({ id }) {
  const { getCompleteItemData } = useManageClassController();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const { handleError } = useMessage();

  React.useEffect(() => {
    setLoading(true);
    getCompleteItemData(id)
      .then((response) => {
        setItem(response);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setItem([]);
        handleError('Erro ao buscar detalhe do candidato(a)!');
      });
  }, [getCompleteItemData, handleError, id]);

  if (loading) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <BaSeParagraph>
        <BaSeParagraph>
          <BaSeSmall1>
            <strong>Turma:</strong>
            {` ${item.classNameLinked ?? ''}`}
          </BaSeSmall1>
        </BaSeParagraph>
        <BaSeSmall1>
          <strong>CPF:</strong>
          {` ${cpfMask(item.cpf ?? '')}`}
        </BaSeSmall1>
      </BaSeParagraph>
      <BaSeParagraph>
        <BaSeSmall1>
          <strong>Telefone:</strong>
          {` ${phoneMask(item.phone ?? '')}`}
        </BaSeSmall1>
      </BaSeParagraph>
      <BaSeParagraph>
        <BaSeSmall1>
          <strong>E-mail:</strong>
          {` ${item.email}`}
        </BaSeSmall1>
      </BaSeParagraph>
      <BaSeParagraph>
        <BaSeSmall1>
          <strong>UF:</strong>
          {` ${item.uf}`}
        </BaSeSmall1>
      </BaSeParagraph>
    </div>
  );
}

export default PersonalItems;
